
// 인증서 관리
// 인증서 발급
//
// @since 2018-03-28
// @author 강정규 ( devp012 )

import {pcDownloadFile} from '~/utils/files'

export const state = () => ({
  urlVpnConfig: '/api/sm/cert-issue', // VPN 인증서 발급 설정
  urlVpnCerts: '/api/sm/cert-issue/certs', // VPN 인증서 목록 조회
  urlSslCerts: '/api/sm/cert-issue/ssl-certs', // SSL 트래픽 인증서 목록 조회
  urlSslCertTrusts: '/api/sm/cert-issue/ssl-cert-trusts', // SSL 트래픽 인증서 목록 조회

  // VPN 용 인증서
  // vpnConfig: {
  //   ip_ver: 0, //        required (one of 0, 1) IP 주소 버전(IPv4: 1, IPv6: 2)
  //   ip: '', //           required (string) CA 인증 서버 IP 주소(IPv4 Address or IPv6 Address)
  //   auth_password: '' // required (string - minLength: 9 - maxLength: 32)
  //   //                   인증 비밀번호(PUT Method만 해당하는 속성) Base64로 인코딩하여 전달한다.
  //   //                   9자 이상, 32자 이하의 영문/숫자/특수문자 조합
  //   //                   Well-known Word(admin,administrator,test,qwe,user) 사용 불가
  // },

  vpnCertList: [], // VPN 인증서 발급 리스트

  dialogMode: '', // "VPN" or "SSL"

  // 인증서 발급 팝업
  dialogData: {
    cert_name: '', //         required (string - maxLength: 32) 인증서 ID
    country: '', //           required (one of KR, US, JP, CN) 국가 코드 (대한민국: KR, 미국: US, 일본: JP, 중국: CN)
    state: '', //             required (string - maxLength: 32) 주/도
    location: '', //          required (string - maxLength: 32) 도시
    organization: '', //      required (string - maxLength: 32) 조직
    organization_unit: '', // required (string - maxLength: 32) 부서
    common_name: '', //       required (string - maxLength: 32) 별칭
    email: '', //             required (string - maxLength: 32) 메일 주소

    // VPN
    vpn_ip: '', //   (string - maxLength: 46) VPN 장비 주소

    // SSL
    cert_bit: 512 //      required (one of 512, 1024, 2048) 인증서 비트 수
  },

  // SSL 트래픽 검사용 인증서
  sslCertList: [], // SSL 인증서 리스트
  sslCertTrustList: [] // 신뢰할수 있는 인증서
})

export const mutations = {
  // VPN 인증서 발급 설정 조회
  // getCertIssueVpnConfig: (state, data) => {
  //   state.vpnConfig.ip = data.ip
  // },
  // VPN 인증서 목록 조회
  getCertIssueVpnCert: (state, items) => {
    state.vpnCertList = items
  },
  // VPN 인증서 추가
  addCertIssueVpnCert: (state, item) => {
    state.vpnCertList.push(item)
  },
  // VPN 인증서 삭제
  delCertIssueVpnCert: (state, itemList) => {
    for (const itemKey of itemList.items) {
      const idx = _.findIndex(state.vpnCertList, {cert_name: itemKey.cert_name})
      if (idx >= 0) {
        state.vpnCertList.splice(idx, 1)
      }
    }
  },
  // SSL 트래픽 인증서 목록 조회
  getCertIssueSslCert: (state, items) => {
    state.sslCertList = items
  },
  // SSL 트래픽 인증서 추가
  addCertIssueSslCert: (state, item) => {
    state.sslCertList.push(item)
  },
  // SSL 트래픽 인증서 삭제
  delCertIssueSslCert: (state, itemList) => {
    for (const itemKey of itemList.items) {
      const idx = _.findIndex(state.sslCertList, {ssl_trfc_chk_cert_id: itemKey.ssl_trfc_chk_cert_id})
      if (idx >= 0) {
        state.sslCertList.splice(idx, 1)
      }
    }
  },
  getSslCertTrust: (state, items) => {
    state.sslCertTrustList = items
  },
  // 다이얼로그 초기화
  clearDialogData: (state) => {
    state.dialogData.cert_name = ''
    state.dialogData.country = 'KR'
    state.dialogData.state = ''
    state.dialogData.location = ''
    state.dialogData.organization = ''
    state.dialogData.organization_unit = ''
    state.dialogData.common_name = ''
    state.dialogData.email = ''

    // VPN
    state.dialogData.vpn_ip = ''

    // SSL
    state.dialogData.cert_bit = 512
  }
}

export const actions = {
  // VPN Config ///////////////////////////////////////////////////////////////////////////////////
  // VPN 인증서 발급 설정 조회
  async getCertIssueVpnConfig ({state}) {
    const data = await this.$axios.$get(state.urlVpnConfig)
    return data
  },
  // VPN 인증서 발급 설정 조회
  async setCertIssueVpnConfig ({commit, state}, param) {
    const {code} = await this.$axios.$put(state.urlVpnConfig, param)
    if (code === 'ok') {
      return true
    }
    return false
  },
  async finalCommand ({commit, state}, type) {
    let param = {}
    if (type === 'apply') {
      param = { applyMsg: true }
    } else {
      param = { cancelMsg: true }
    }
    const {code} = await this.$axios.$put(`${state.urlVpnConfig}/${type}`, null, param)
    if (code === 'ok') {
      return true
    }
    return false
  },

  // VPN 인증서 목록 조회
  async getCertIssueVpnCert ({commit, state}) {
    const {code, result} = await this.$axios.$get(state.urlVpnCerts)
    if (code === 'ok') {
      commit('getCertIssueVpnCert', result)
      return true
    }
    return false
  },
  // VPN 인증서 추가
  async addCertIssueVpnCert ({commit, state}) {
    const param = _.cloneDeep(state.dialogData)
    delete param.cert_bit
    const {code, result} = await this.$axios.$post(state.urlVpnCerts, param)

    if (code === 'ok') {
      commit('addCertIssueVpnCert', result)
      return true
    }
    return false
  },
  // VPN 인증서 삭제
  async delCertIssueVpnCert ({commit, state}, param) {
    if (param.items.length === 1) {
      const data = await this.$axios.$delete(`${state.urlVpnCerts}/${param.items[0].cert_name}`)
      if (data.code === 'ok') {
        commit('delCertIssueVpnCert', param)
        return true
      }
      return false
    } else {
      const data = await this.$axios.$delete(`${state.urlVpnCerts}`, {data: param})
      if (data.code === 'ok') {
        commit('delCertIssueVpnCert', param)
      }
      return data
    }
  },
  // VPN 인증서 PC 저장
  async expCertIssueVpnCert ({commit, state}, param) {
    const {data, fileName} = await this.$axios.$file(`${state.urlVpnCerts}/${param.keyValue}/export`, {params: param.param, responseType: 'blob'})
    pcDownloadFile(data, fileName)
  },

  // SSL 트래픽 검사용 인증서
  async getCertIssueSslCert ({commit, state}) {
    const {code, result} = await this.$axios.$get(state.urlSslCerts)
    if (code === 'ok') {
      commit('getCertIssueSslCert', result)
      return true
    }
    return false
  },
  // SSL 트래픽 인증서 추가
  async addCertIssueSslCert ({commit, state}) {
    const param = _.cloneDeep(state.dialogData)
    delete param.vpn_ip
    const {code, result} = await this.$axios.$post(state.urlSslCerts, param)

    if (code === 'ok') {
      commit('addCertIssueSslCert', result)
      return true
    }
    return false
  },
  // SSL 트래픽 인증서 삭제
  async delCertIssueSslCert ({commit, state}, param) {
    if (param.items.length === 1) {
      const data = await this.$axios.$delete(`${state.urlSslCerts}/${param.items[0].ssl_trfc_chk_cert_id}`)
      if (data.code === 'ok') {
        commit('delCertIssueSslCert', param)
        return true
      }
      return false
    } else {
      const data = await this.$axios.$delete(`${state.urlSslCerts}`, {data: param})
      if (data.code === 'ok') {
        commit('delCertIssueSslCert', param)
      }
      return data
    }
  },
  // SSL 트래픽 인증서 PC 저장
  async expCertIssueSslCert ({commit, state}, param) {
    const {data, fileName} = await this.$axios.$file(`${state.urlSslCerts}/${param.keyValue}/export`, {params: param.param, responseType: 'blob'})
    pcDownloadFile(data, fileName)
  },

  async getSslCertTrust ({commit, state}) {
    const {code, result} = await this.$axios.$get(state.urlSslCertTrusts)
    if (code === 'ok') {
      commit('getSslCertTrust', result)
      return true
    }
    return false
  }
}

export const getters = {
  getTest () {
    return 1
  }
}

export const strict = false
